module.exports = __webpack_public_path__ + "static/media/style.4a9c15b4.svg";